import axiosApi from "../axiosInstance";

const getVendorList = async () => {
    try {
        //debugger;
        const response = await axiosApi.get(`Vendor/GetVendorList`);
        return response?.data;
    } catch (error) {
        console.log("Error getVendorList===>:", error);
    }
};
const GetVendorDropdown = async () => {
    try {
        //debugger;
        const response = await axiosApi.get(`Vendor/GetVendorDropdown`);
        return response?.data;
    } catch (error) {
        console.log("Error GetVendorDropdown===>:", error);
    }
};

const getVendorBankDetailsByVendorId = async (vendorId) => {
    try {
        //debugger;
        const response = await axiosApi.post(`Vendor/GetVendorBankDetailsByVendorId/` + vendorId);
        return response?.data;
    } catch (error) {
        console.log("Error getVendorBankDetailsByVendorId===>:", error);
    }
};


export const VendorService = {
    getVendorList,
    getVendorBankDetailsByVendorId,
    GetVendorDropdown
}